import React from "react";
import { NavLink } from "react-router-dom";

import Button from "../button/button";

// import "./NavigationItems.css";
import "./about.css";

function Text(props) {
  return (
    <div id="aboutPage" className="page">
      <h1>About</h1>
      <hr />
      {props.isAuth && (
        <Button design="raised" mode="accent" onClick={props.onStartEdit}>
          {props.children ? "Edit about" : "Add a new about"}
        </Button>
      )}
      <div style={{width: "80%", }}>
        <p>{props.children}</p>
      </div>
    </div>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Text;
